<!--

 -->

<template>
  <oxd-icon-button name="share-fill" :with-container="true" />
</template>

<script>
export default {
  name: 'PostShareButton',
};
</script>
